module.exports = __webpack_public_path__ + "img/Logo Horizontal Color_Beta.bb9fc92.png";